 <template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="companies"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			:check-all="checkAll"
			selectable
			@on-search-event="onSearch"
			@on-page="changePage"
			@on-selected-all="$emit('on-selected-all', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.nombreComercial }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.hash }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.razonSocial }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.codeCompany }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.ruc }}
				</td>
				<td v-show="showRow(columns, 6)">
					{{ props.row.namePlan }}
				</td>
				<td v-show="showRow(columns, 7)">
					{{ props.row.expirationDate }}
				</td>
				<td v-show="showRow(columns, 8)">
					{{ '-' }}
				</td>
				<td>
					<div class="d-flex align-center">
						<v-tooltip top v-if="codeProject === 'maki_project'"  >
							<v-btn
								flat
								icon
								small
								slot="activator"
								color="blue"
								@click="renewCompany(props.row)">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
									<rect x="8" y="12" width="48" height="44" rx="6" fill="white" stroke="#222" stroke-width="3"/>
									<line x1="8" y1="22" x2="56" y2="22" stroke="#222" stroke-width="3"/>
									
									<line x1="20" y1="6" x2="20" y2="18" stroke="#222" stroke-width="3" stroke-linecap="round"/>
									<line x1="44" y1="6" x2="44" y2="18" stroke="#222" stroke-width="3" stroke-linecap="round"/>

									<text x="20" y="46" font-size="20" font-family="Arial" fill="#222" font-weight="bold">28</text>

									<line x1="14" y1="16" x2="50" y2="52" stroke="#FF3B30" stroke-width="6" stroke-linecap="round"/>
									<line x1="50" y1="16" x2="14" y2="52" stroke="#FF3B30" stroke-width="6" stroke-linecap="round"/>
								</svg>
							</v-btn>
							<span>Renovar 1 año</span>
						</v-tooltip>
						<v-tooltip top v-if="codeProject === 'maki_project'">
							<v-btn
								flat
								icon
								small
								slot="activator"
								color="purple"
								@click="openIaLimitModal(props.row)">
								<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
									<path d="M12 2L14.2 9.8L22 12L14.2 14.2L12 22L9.8 14.2L2 12L9.8 9.8L12 2Z" fill="#8E24AA"/>
									<path d="M19 2L19.9 5.1L23 6L19.9 6.9L19 10L18.1 6.9L15 6L18.1 5.1L19 2Z" fill="#BA68C8"/>
								</svg>
							</v-btn>
							<span>Aumentar límite de escaneo IA</span>
						</v-tooltip>
						<app-tooltip-button
							color="green"
							icon="edit"
							text="Editar Compañía"
							@click-icon="edit(props.row)"
						/>
						<app-tooltip-button
							color="blue"
							icon="people_outline"
							text="Usuarios"
							@click-icon="goToUsers(props.row)"
						/>
						<app-tooltip-button
							color="red"
							icon="playlist_add_check"
							text="Roles"
							@click-icon="openRoles(props.row)"
						/>
						<v-tooltip top>
							<v-switch
								slot="activator"
								color="green"
								class="mt-0"
								hide-details
								v-model="props.row.flagBlocked"
								@change="blockedCompany(props.row)"
							></v-switch>
							<span class="text-center">{{ props.row.flagBlocked ? 'Desbloquear' : 'Bloquear' }} compañía</span>
						</v-tooltip>
					</div>
				</td>
			</template>
		</app-table>
		<v-dialog v-model="iaLimitModal.visible" max-width="500" :persistent="iaLimitModal.loadingSaving">
			<v-card>
				<v-card-title class="subheading font-weight-bold d-flex align-center justify-space-between py-2 px-4 grey lighten-3">
					<div class="d-flex align-center">
						<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" class="mr-2">
							<path d="M12 2L14.2 9.8L22 12L14.2 14.2L12 22L9.8 14.2L2 12L9.8 9.8L12 2Z" fill="#8E24AA"/>
							<path d="M19 2L19.9 5.1L23 6L19.9 6.9L19 10L18.1 6.9L15 6L18.1 5.1L19 2Z" fill="#BA68C8"/>
						</svg>
						<span>Aumentar Límite de Escaneo IA</span>
					</div>
					<v-btn
						icon
						small
						class="ma-0"
						:disabled="iaLimitModal.loadingSaving"
						@click="closeIaLimitModal"
					>
						<v-icon color="grey darken-2">close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="pt-4 px-4 pb-2">
					<v-progress-linear
						v-if="iaLimitModal.loadingData"
						indeterminate
						color="purple"
						class="mb-3"
					></v-progress-linear>

					<div class="mb-3">
						<div class="body-1 font-weight-bold text-truncate">
							{{ iaLimitModal.company.nombreComercial || iaLimitModal.company.razonSocial || 'Compañía' }}
						</div>
						<div class="caption grey--text text--darken-1">
							RUC: {{ iaLimitModal.company.ruc || '-' }} | Código: {{ iaLimitModal.company.codeCompany || '-' }}
						</div>
					</div>

					<v-layout row wrap class="mb-3">
						<v-flex xs6 pr-2>
							<v-card flat class="grey lighten-4 pa-2 text-xs-center">
								<div class="caption grey--text text--darken-1">Límite actual</div>
								<div class="title font-weight-bold purple--text">
									{{ iaLimitModal.currentLimit }}
								</div>
							</v-card>
						</v-flex>
						<v-flex xs6 pl-2>
							<v-card flat class="grey lighten-4 pa-2 text-xs-center">
								<div class="caption grey--text text--darken-1">Uso actual</div>
								<div class="title font-weight-bold blue--text">
									{{ iaLimitModal.currentUse }}
								</div>
							</v-card>
						</v-flex>
					</v-layout>

					<v-text-field
						label="Nuevo límite de escaneo"
						type="number"
						v-model.number="iaLimitModal.newLimit"
						:min="iaLimitModal.currentLimit + 1"
						:error-messages="limitErrorMessage"
						:disabled="iaLimitModal.loadingData || iaLimitModal.loadingSaving"
						hint="El nuevo límite siempre debe ser mayor al límite actual"
						persistent-hint
						box
						background-color="white"
						class="body-1 mt-2"
					></v-text-field>

					<div class="mt-2 mb-1">
						<span class="caption grey--text text--darken-2">Incremento rápido:</span>
						<div class="mt-1 d-flex">
							<v-btn
								v-for="inc in [10, 25, 50, 100]"
								:key="inc"
								small
								outline
								color="purple"
								class="mr-2 my-0"
								:disabled="iaLimitModal.loadingData || iaLimitModal.loadingSaving"
								@click="addIncrement(inc)"
							>
								+{{ inc }}
							</v-btn>
						</div>
					</div>
				</v-card-text>

				<v-card-actions class="justify-end px-4 pb-3 pt-0">
					<v-btn
						class="btn-action caption"
						flat
						:disabled="iaLimitModal.loadingSaving"
						@click="closeIaLimitModal"
					>
						Cancelar
					</v-btn>
					<v-btn
						class="btn-action caption"
						color="purple"
						dark
						:loading="iaLimitModal.loadingSaving"
						:disabled="!isLimitValid || iaLimitModal.loadingSaving || iaLimitModal.loadingData"
						@click="saveIaLimit"
					>
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function edit({ id, nombreComercial, codeCompany }) {
	const idCompany = id;
	const nameCompany = nombreComercial;
	this.goTo('page-edit-company', { params: { idCompany, codeCompany, nameCompany } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openRoles({ codeCompany }) {
	this.goTo('page-role', { params: { codeCompany, codeProject: this.codeProject } });
}

function goToUsers({ codeCompany }) {
	this.goTo('page-user', { params: { codeProject: this.codeProject, idCompany: codeCompany } });
}

async function renewCompany({ id, nombreComercial }) {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		const conf = confirm(`¿Estás seguro de que deseas renovar 1 año para ${nombreComercial || 'esta empresa'}?`);
		 if (conf) {
			await this.$http.patch(`company-renewal/${id}`, null, { headers });
			this.showNotification(`Se renovo la compañía ${nombreComercial} correctamente`);
		 }
	} catch (error) {
		this.showNotification('No se pudo renovar la compañía', 'error');
	}
}

async function openIaLimitModal(row) {
	this.iaLimitModal.company = row;
	this.iaLimitModal.visible = true;
	this.iaLimitModal.loadingData = true;

	let limit = 0;
	let use = 0;
	let total = 0;
	if (row.progress && row.progress['Conteo IA']) {
		limit = Number(row.progress['Conteo IA'].countAllow) || 0;
		use = Number(row.progress['Conteo IA'].countUse) || 0;
		total = Number(row.progress['Conteo IA'].totalCount) || 0;
	}

	this.iaLimitModal.currentLimit = limit;
	this.iaLimitModal.currentUse = use;
	this.iaLimitModal.totalCount = total;
	this.iaLimitModal.newLimit = limit > 0 ? limit + 10 : 30;

	try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const response = await this.$http.get(`level-progress/${row.id}`, { headers });
		if (response && response.data && response.data.progress && response.data.progress['Conteo IA']) {
			const conteo = response.data.progress['Conteo IA'];
			limit = Number(conteo.countAllow) || 0;
			use = Number(conteo.countUse) || 0;
			total = Number(conteo.totalCount) || 0;
			this.iaLimitModal.currentLimit = limit;
			this.iaLimitModal.currentUse = use;
			this.iaLimitModal.totalCount = total;
			this.iaLimitModal.newLimit = limit > 0 ? limit + 10 : 30;
		}
	} catch (error) {
		// Se mantiene lo obtenido de la fila si falla la petición
	} finally {
		this.iaLimitModal.loadingData = false;
	}
}

function addIncrement(amount) {
	const current = Number(this.iaLimitModal.currentLimit) || 0;
	this.iaLimitModal.newLimit = current + amount;
}

function closeIaLimitModal() {
	if (this.iaLimitModal.loadingSaving) return;
	this.iaLimitModal.visible = false;
	this.iaLimitModal.company = {};
	this.iaLimitModal.newLimit = null;
}

async function saveIaLimit() {
	if (!this.isLimitValid) return;

	const { id } = this.iaLimitModal.company;
	const newLimit = Number(this.iaLimitModal.newLimit);
	this.iaLimitModal.loadingSaving = true;

	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};

	try {
		await this.$http.patch(`company-ia-limit/${id}`, { countAllow: newLimit }, { headers });
		this.showNotification(`Se aumentó el límite de escaneo IA a ${newLimit} correctamente`);

		const companyRow = this.rows.find(r => r.id === id);
		if (companyRow) {
			if (!companyRow.progress) {
				companyRow.progress = {};
			}
			if (!companyRow.progress['Conteo IA']) {
				companyRow.progress['Conteo IA'] = {
					countUse: this.iaLimitModal.currentUse,
					totalCount: this.iaLimitModal.totalCount,
					countAllow: newLimit,
				};
			} else {
				companyRow.progress['Conteo IA'].countAllow = newLimit;
			}
		}

		this.closeIaLimitModal();
	} catch (error) {
		const message = error.response && error.response.data && error.response.data.message
			? error.response.data.message
			: 'No se pudo actualizar el límite de escaneo IA';
		this.showNotification(message, 'error');
	} finally {
		this.iaLimitModal.loadingSaving = false;
	}
}

export default {
	name: 'companies-list',
	components: {
		appTooltipButton,
	},
	data() {
		return {
			iaLimitModal: {
				visible: false,
				loadingData: false,
				loadingSaving: false,
				company: {},
				currentLimit: 0,
				currentUse: 0,
				totalCount: 0,
				newLimit: null,
			},
		};
	},
	computed: {
		isLimitValid() {
			if (this.iaLimitModal.newLimit === null || this.iaLimitModal.newLimit === '' || isNaN(this.iaLimitModal.newLimit)) {
				return false;
			}
			const val = Number(this.iaLimitModal.newLimit);
			return Number.isInteger(val) && val > this.iaLimitModal.currentLimit;
		},
		limitErrorMessage() {
			if (this.iaLimitModal.newLimit === null || this.iaLimitModal.newLimit === '') {
				return [];
			}
			const val = Number(this.iaLimitModal.newLimit);
			if (isNaN(val) || !Number.isInteger(val)) {
				return ['El límite debe ser un número entero.'];
			}
			if (val <= this.iaLimitModal.currentLimit) {
				return [`El nuevo límite debe ser mayor al límite actual (${this.iaLimitModal.currentLimit}).`];
			}
			return [];
		},
	},
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		checkAll: {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		changePage,
		edit,
		onSearch,
		openRoles,
		goToUsers,
		openIaLimitModal,
		addIncrement,
		closeIaLimitModal,
		saveIaLimit,
		async blockedCompany(row) {
			const { flagBlocked, id, nombreComercial } = row;
			const message = flagBlocked ? 'bloqueo' : 'desbloqueo';
			const body = {
				flagBlocked: flagBlocked ? 1 : 0,
			};
			try {
				await this.$http.patch(`company/${id}/blocked`, body);
				this.showNotification(`Se ${message} la compañía ${nombreComercial} correctamente`);
			} catch (error) {
				this.showNotification('No se pudo bloquear la compañía', 'error');
			}
		},
		renewCompany,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/companies/company-list.vue